<template>
  <pagefra>
    <div
      class="accountVideoDevice container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('设备号')">
              <el-input
                v-model="form.deviceSerial"
                :placeholder="$l('设备号')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd(1)"
              v-show="hasPermission('绑定设备')"
              >{{ $l("绑定设备") }}
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd(2)"
              v-show="hasPermission('设备授权')"
              >{{ $l("设备授权") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="filterTableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('设备号')"
              prop="deviceSerial"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('通道号')"
              prop="channelNo"
              align="center"
              min-width="80"
            ></el-table-column>
            <el-table-column
              :label="$l('权限')"
              prop="permission"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('视频加密')"
              min-width="80"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('视频加密')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="
                    showVideoEncrypt(scope.row.deviceSerial)
                  "
                  type="primary"
                  clear
                  icon="el-icon-setting"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pages"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        ref="editDialog"
        :visible.sync="editDialogVisible"
        width="540px"
      >
        <div slot="title" class="dialog-title">
          {{ $l(editDialogTitle) }}
        </div>
        <el-form
          ref="editForm"
          :model="editForm"
          label-width="140px"
          size="medium"
          class="dialog-form"
          :rules="rules"
        >
          <el-form-item :label="$l('设备号')" prop="deviceSerial">
            <span class="required">*</span>
            <el-input v-model="editForm.deviceSerial"></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('设备验证码')"
            prop="validateCode"
            v-if="addType == 1"
          >
            <span class="required">*</span>
            <el-input v-model="editForm.validateCode"></el-input>
          </el-form-item>
          <el-form-item :label="$l('通道号')" prop="channelNo" v-else>
            <el-input v-model="editForm.channelNo"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex">
            <el-col>
              <el-button round @click="editDialogVisible = false"
                >{{ $l("取消") }}
              </el-button>
              <el-button round type="primary" @click="submit"
                >{{ $l("确定") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="encryptDialogVisible" width="540px">
        <div slot="title" class="dialog-title">
          {{ $l(encryptDialogTitle) }}
          <span v-if="deviceStatus != null"
            >--<span :style="{ color: deviceStatus == 1 ? 'green' : 'red' }">{{
              deviceStatus == 1 ? $l("设备在线") : $l("设备不在线")
            }}</span></span
          >
        </div>
        <el-form label-width="140px" size="medium" class="dialog-form">
          <el-form-item :label="$l('是否加密')">
            <el-radio v-model="isEncrypt" label="1">{{ $l('是') }}</el-radio>
            <el-radio v-model="isEncrypt" label="0">{{ $l('否') }}</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex">
            <el-col>
              <el-button round @click="encryptDialogVisible = false"
                >{{ $l("取消") }}
              </el-button>
              <el-button round type="primary" @click="setVideoEncrypt"
                >{{ $l("确定") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "accountVideoDevice",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateDeviceSerial = (rule, value, callback) => {
      if (value == null || value.trim().length == 0 || value.length > 50) {
        callback(new Error(this.$l("请输入设备号，且长度不超过50个字符!")));
      } else {
        callback();
      }
    };
    var validateChannelNo = (rule, value, callback) => {
      if (value && value.trim().length > 0 && (isNaN(value) || value <= 0)) {
        callback(new Error(this.$l("请输入大于0的数字!")));
      } else {
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      // const re = /^[A-Z]{6}$/;
      if (value == null || value.trim().length == 0) {
        callback(new Error(this.$l("请输入设备验证码!")));
      } else {
        callback();
      }
    };
    return {
      form: {
        deviceSerial: null,
      },
      tableData: [],
      filterTableData: [],
      loading: false,
      fullLoading: false,
      editDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        validateCode: null,
        deviceSerial: null,
        channelNo: null,
      },
      addType: 1,
      rules: {
        deviceSerial: [{ validator: validateDeviceSerial, trigger: "blur" }],
        channelNo: [{ validator: validateChannelNo, trigger: "blur" }],
        validateCode: [{ validator: validateCode, trigger: "blur" }],
      },
      pages: [10, 20, 30, 40, 50],
      encryptDialogVisible: false,
      encryptDialogTitle: "",
      isEncrypt: null, //是否加密
      deviceSerial: null,
      deviceStatus: null,
    };
  },
  mounted() {
    if (this.loaded) {
      this.pageConfig.pageSize = this.pages[0];
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage - 1;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_sub_account_device_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            const deviceSerial = this.form.deviceSerial;
            if (deviceSerial && deviceSerial.trim().length > 0) {
              this.filterTableData = this.tableData.filter(
                (t) => t.deviceSerial.indexOf(deviceSerial.trim()) >= 0
              );
            } else {
              this.filterTableData = this.tableData;
            }
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showAdd(type) {
      this.addType = type;
      for (let key in this.editForm) {
        this.editForm[key] = null;
      }
      this.editDialogTitle = this.addType == 1 ? "绑定设备" : "设备授权";
      this.editDialogVisible = true;
      this.$refs.editForm.clearValidate();
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const url =
            this.addType == 1
              ? this.$apiConfig.add_device_url
              : this.$apiConfig.add_sub_account_device_url;
          this.$http
            .post(url, this.editForm)
            .then((response) => {
              let data = response.data;
              this.message(data.code, data.msg);
              if (data.code == 0) {
                this.editDialogVisible = false;
                if (this.addType == 2) {
                  this.search();
                }
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    showVideoEncrypt(deviceSerial) {
      this.isEncrypt = null;
      this.deviceStatus = null;
      this.deviceSerial = deviceSerial;
      this.encryptDialogTitle = `${this.$l('视频加密')}(${deviceSerial})`;
      this.$http
        .get(this.$apiConfig.get_single_device_info_url, {
          params: {
            deviceSerial,
          },
        })
        .then((response) => {
          let result = response.data;
          this.encryptDialogVisible = true;
          if (result.code == 0) {
            const data = result.data;
            if (data) {
              this.isEncrypt = result.data.isEncrypt + "";
              this.deviceStatus = data.status;
            } else {
              this.message(1, "获取不到设备信息");
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
          this.encryptDialogVisible = true;
        });
    },
    setVideoEncrypt() {
      if (!this.isEncrypt) {
        return;
      }
      this.$http
        .post(this.$apiConfig.set_video_encrypt_url, {
          deviceSerial: this.deviceSerial,
          type: parseInt(this.isEncrypt),
        })
        .then((response) => {
          let result = response.data;
          this.message(result.code, result.msg);
          if(result.code == 0) {
            this.encryptDialogVisible = false;
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.accountVideoDevice {
  .dialog-form {
    .el-input {
      width: 300px;
    }
    /deep/ .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
      width: 300px;
    }
    .required {
      color: red;
      display: inline-block;
      position: absolute;
      left: -10px;
      top: 2px;
    }
    /deep/ .el-form-item__error {
      position: static;
    }
  }
}
</style>
